module.exports = __webpack_public_path__ + "img/upper_ruffle_length.f80e4282.png";